import http from 'utils/http';
import { getIntegrationsUrl, getIntegrationUrl } from './apiUrls';
import { AvailableIntegrationResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getAvailableIntegrations(): Promise<{
  data: AvailableIntegrationResponse[];
  meta: MetaApiResponse;
}> {
  return http.get(getIntegrationsUrl());
}

export function getAvailableIntegration(id: string): Promise<AvailableIntegrationResponse> {
  return http.get(getIntegrationUrl(id));
}

export function configureIntegration(
  id: string,
  payload: { business_ids: number[] }
): Promise<AvailableIntegrationResponse> {
  return http.put(getIntegrationUrl(id), payload);
}
